module.exports = __webpack_public_path__ + "static/media/fly0070.8751278d.webp";